export const transformBarToTable = (apiresponse) => {
  const key = Object.keys(apiresponse)[0]
  const tableData = apiresponse[key];
  const sortedMonths = Object.keys(tableData).sort((a, b) => {
    const parseMonth = (str) => {
      const [month, year] = str.split(' ');
      return new Date(`${month} 1, ${year}`);
    };
    return parseMonth(a) - parseMonth(b);
  });
  const statuses = new Set();
  const colHeader = ['Status'];
  const finalData = [];
  sortedMonths.forEach((month) => {
    const monthData = tableData[month];
    colHeader.push(month);
    Object.keys(monthData).forEach((category) => { statuses.add(category) });
  });
  const preferredOrder = ["To Do", "In Progress", "Done", "Total (Issues)"];
  const orderedStatuses = [
    ...preferredOrder.filter(status => statuses.has(status)),
    ...Array.from(statuses).filter(status => !preferredOrder.includes(status))
  ];
  orderedStatuses.forEach((status, idx) => {
    const obj = {}
    obj['Status'] = status;
    colHeader.forEach((month, idx) => {
      if (idx !== 0) {
        obj[month] = tableData[month][status] || 0;
      }
    });
    finalData.push(obj);
  })
  return finalData;
}

export const StatusDashboardData = [
  {
    id: 0,
    name: "Agenda",
    type: "list",
    url: "/jira/vCISO/getWeeklyAgenda",
    size: 6,
    class: "medium-row",
  },
  {
    id: 1,
    name: "Summary",
    type: "list",
    url: "/jira/vCISO/getWeeklySummary",
    size: 5,
    class: "medium-row",
  },
  {
    id: 2,
    name: "Monthly % Completed Table",
    type: "table",
    url: "/jira/vCISO/getMonthlyReport",
    transformFn: transformBarToTable,
    size: 6,
    class: "medium-row total-bold",
  },
  {
    id: 3,
    name: "Monthly % Completed Chart",
    type: "multibarchart",
    showPercent: true,
    url: "/jira/vCISO/getMonthlyReport",
    size: 5,
    class: "medium-row",
  },
  {
    id: 4,
    name: "Work Type Distribution",
    type: "piechart",
    url: "/jira/vCISO/getWorkTypeReport",
    size: 6,
    class: "medium-row",
  },
  {
    id: 5,
    name: "Work Type (Month-on-Month) Distribution",
    type: "multibarchart",
    url: "/jira/vCISO/getWorkTypeReport",
    size: 5,
    class: "medium-row",
  },
  {
    id: 6,
    name: "vCISO Annual Stats",
    type: "header",
    size: 12,
    class: "medium-row",
  },
  {
    id: 7,
    name: "Annual Percentage Completed",
    type: "table",
    transformFn: transformBarToTable,
    url: "/jira/vCISO/getMonthlyReport?type=YEAR",
    size: 12,
    class: "medium-row total-bold",
  },
  {
    id: 8,
    name: "Annual Percentage Completed",
    type: "multibarchart",
    url: "/jira/vCISO/getMonthlyReport?type=YEAR",
    size: 12,
    class: "medium-row",
  },
  {
    id: 9,
    name: "vCSM Indian Head - IHC: In Progress",
    type: "table",
    cellClass: "tbl-cell",
    desiredOrder: ["Summary", "Status", "Start date", "Due date"],
    url: "/jira/vCISO/statusReport?status=In Progress",
    size: 12,
    class: "medium-row",
  },
  {
    id: 10,
    name: "vCSM Indian Head - IHC: March 2025",
    cellClass: "tbl-cell",
    type: "table",
    desiredOrder: ["Summary", "Status", "Start date", "Due date"],
    url: "/jira/vCISO/statusReport?startOfMonth=-1&endOfMonth=0",
    size: 12,
    class: "medium-row",
  },
  {
    id: 11,
    name: "vCSM Indian Head - IHC: April 2025",
    cellClass: "tbl-cell",
    type: "table",
    desiredOrder: ["Summary", "Status", "Start date", "Due date"],
    url: "/jira/vCISO/statusReport?startOfMonth=0&endOfMonth=1",
    size: 12,
    class: "medium-row",
  },
  {
    id: 12,
    name: "vCSM Indian Head - IHC: May 2025",
    cellClass: "tbl-cell",
    type: "table",
    desiredOrder: ["Summary", "Status", "Start date", "Due date"],
    url: "/jira/vCISO/statusReport?startOfMonth=1&endOfMonth=2",
    size: 12,
    class: "medium-row",
  },
  {
    id: 13,
    name: "vCSM Indian Head - IHC: June 2025",
    cellClass: "tbl-cell",
    type: "table",
    desiredOrder: ["Summary", "Status", "Start date", "Due date"],
    url: "/jira/vCISO/statusReport?startOfMonth=2&endOfMonth=3",
    size: 12,
    class: "medium-row",
  },
];
